import React, {
    useEffect,
    useState,
    useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import Head from 'bdvp-common/src/components/Head';
import { useDidUpdate } from 'bdvp-common/src/hooks';
import { useDictionary, useClubName } from 'bdvp-common/src/hooks/config';
import scrollRestore from 'bdvp-common/src/utils/scrollRestore';
import { Tracking } from 'bdvp-tracking';

import Homepage from '../../containers/Homepage';
import Message from '../../containers/Message';
import SearchResults from '../../containers/SearchResults';

const SearchPage = (props) => {

    const {
        query,
        queryInfoError,
        setSelectedFilters,
        resetPageNumber,
    } = props;

    const location = useLocation();
    const {
        searchpage_title = '{{clubName}} Video Search | MLB Film Room',
        searchpage_description = 'Search {{clubName}} video highlights by player, team, matchups, and stats.',
    } = useDictionary();

    const clubName = useClubName();

    const [
        isClient,
        setIsClient,
    ] = useState(false);

    const [
        locationSearchWasUpdated,
        setLocationSearchWasUpdated,
    ] = useState(false);

    const locationSearchRef = useRef(location.search);

    useEffect(() => {

        setLocationSearchWasUpdated(location.search !== locationSearchRef.current);

        scrollRestore({ behavior: 'smooth' });

        locationSearchRef.current = location.search;

    }, [location.search]);

    useDidUpdate(()=>{

        resetPageNumber();

    },[query]);

    useEffect(() => {

        setIsClient(true);
        Tracking.trackSearchResultsPageView();

        return () => {

            setSelectedFilters([]);
            resetPageNumber();

        };

    }, []);

    let content;

    if(!isClient) {

        content = null;

    } else if(!query) {

        content = <Homepage />;

    } else if (queryInfoError) {

        content = <Message type={'search_error'} />;

    } else {

        content = <SearchResults locationSearchWasUpdated={locationSearchWasUpdated} />;

    }

    const searchPageTitle = searchpage_title.replace('{{clubName}}', clubName);
    const searchPageDescription = searchpage_description.replace('{{clubName}}', clubName);
    return (
        <>
            <Head
                title={searchPageTitle}
                description={searchPageDescription}
            />
            {content}
        </>
    );

};

SearchPage.propTypes = {
    setSelectedFilters: PropTypes.func.isRequired,
    resetPageNumber: PropTypes.func.isRequired,
    query: PropTypes.string,
    queryInfoError: PropTypes.object,
};

SearchPage.defaultProps = {
    query: '',
    queryInfoError: undefined,
};

export default SearchPage;
